
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexISdlP3zxlAyo4efWhwLYqUpfT_45UzAIQCTBT9ddG7eCgMeta } from "/var/www/html/fullstack-saas/frontend/pages/index.vue?macro=true";
import { default as loginYegehGnjP2bX_1TWUvkzPJnHZgKQCtt64G6F7jy1Mi4Meta } from "/var/www/html/fullstack-saas/frontend/pages/login.vue?macro=true";
import { default as profilep5wzLnaD1_45Tzf48N6MdI7efpdVcN2Nt3kIJhEyxDmrMMeta } from "/var/www/html/fullstack-saas/frontend/pages/profile.vue?macro=true";
import { default as newjanq7LpB2xmoJcgpxMr2IDcgVNE77Gy922zFiur7M_oMeta } from "/var/www/html/fullstack-saas/frontend/pages/apps/new.vue?macro=true";
import { default as settings1I_45i_45xgOZU18U2gs0JYqcchg0RmnhKK6c8xiyn35gpQMeta } from "/var/www/html/fullstack-saas/frontend/pages/settings.vue?macro=true";
import { default as indexQ_45NwTdEOfdhrgmSrApmEpfVSMJl4qJTsviyGQXw_45hEQMeta } from "/var/www/html/fullstack-saas/frontend/pages/apps/index.vue?macro=true";
import { default as indexrjwA2xBUMCLgTry3Rg2M8ikSB_aeLVcKSaBTH_LAl_QMeta } from "/var/www/html/fullstack-saas/frontend/pages/roles/index.vue?macro=true";
import { default as ui_45showcaseotxqsT79SleLprDmKzjGHkAA5ssOvnlZbHbuAkwudN0Meta } from "/var/www/html/fullstack-saas/frontend/pages/ui-showcase.vue?macro=true";
import { default as index0MumZk89qNmBNG_M8KJ_OhconaAy0xAeZNPiu1s3dwEMeta } from "/var/www/html/fullstack-saas/frontend/pages/users/index.vue?macro=true";
import { default as index6AZgnUnJTI6IpJ3Jrquc2FgCVsNkEAb9ZS9tHQ0EXYcMeta } from "/var/www/html/fullstack-saas/frontend/pages/github/index.vue?macro=true";
import { default as log_45analysis5q3h_45zYPtIpKANvJXiAhbAxu6pq5jax2i25cAwQutjIMeta } from "/var/www/html/fullstack-saas/frontend/pages/log-analysis.vue?macro=true";
import { default as process_45test6q6l5McYnGsb_45ojimscvJ6lAvaokk5KpoASgR0MhNB4Meta } from "/var/www/html/fullstack-saas/frontend/pages/process-test.vue?macro=true";
import { default as unauthorizedRMAB8Ucx0YoSPIBPMoAgOYJgKgP5_vl7rqsY1tXTJ4gMeta } from "/var/www/html/fullstack-saas/frontend/pages/unauthorized.vue?macro=true";
import { default as createzmaPIqkaG6vHBpUrA1R_45Ssd7ivXog4B7VwMwRUy8rtEMeta } from "/var/www/html/fullstack-saas/frontend/pages/users/create.vue?macro=true";
import { default as callbackC6lnNzt_ImBFVT9HZesCbYzUK7O_45Do8A1T3by3p_SvsMeta } from "/var/www/html/fullstack-saas/frontend/pages/auth/callback.vue?macro=true";
import { default as build_45historyW9SPA5gq5WHwwzqiX1CxNVNImOBMcOoVjGznzsSHkkIMeta } from "/var/www/html/fullstack-saas/frontend/pages/build-history.vue?macro=true";
import { default as notifications5mQE6_DSOYb_45llm4vFiQ5cSW7efVFSS13AGIQeYGCrQMeta } from "/var/www/html/fullstack-saas/frontend/pages/notifications.vue?macro=true";
import { default as editrArGqS8ccf2oFUXqEhD6GQ2AdWOMXYucsQprylW37ioMeta } from "/var/www/html/fullstack-saas/frontend/pages/apps/[id]/edit.vue?macro=true";
import { default as logsAfljNU_JqwTFK_455ZvyDfMMnY8YbcaMaEdY9dYrSo1qAMeta } from "/var/www/html/fullstack-saas/frontend/pages/apps/[id]/logs.vue?macro=true";
import { default as build_45analysisoiv8oaeZkpIXdpPFZiBHgkMiMhkIhSDkS_45avoYseHn8Meta } from "/var/www/html/fullstack-saas/frontend/pages/build-analysis.vue?macro=true";
import { default as confirmDQnK2Uyip_6AAYZnjGvpjxyMZoED8TrA7ty8jkFGnSkMeta } from "/var/www/html/fullstack-saas/frontend/pages/reset-password/confirm.vue?macro=true";
import { default as reset_45passwordfIO5daDuajrQH48qgqE4TIWk76CSx0ORzHc_45_GMyOKAMeta } from "/var/www/html/fullstack-saas/frontend/pages/reset-password.vue?macro=true";
import { default as indexQjWwSI3RBic3GTiJqthKXsQs_jRlb5gcO_45uch1BKOH4Meta } from "/var/www/html/fullstack-saas/frontend/pages/apps/[id]/index.vue?macro=true";
import { default as index_45newNJo4ZIQFBSScM_MqNtFDr6RRkC6sCFOWbrJ7hGkBeToMeta } from "/var/www/html/fullstack-saas/frontend/pages/users/index-new.vue?macro=true";
import { default as indexYHBbL9ofQqrqQO2gv_VAoGnyqNxAF4bkJ7nVA4SekrYMeta } from "/var/www/html/fullstack-saas/frontend/pages/users/[id]/index.vue?macro=true";
import { default as _91id_93jo4rwlGVtokDAPAtGgKbyxUMtJ50X9uUVTTLR_oLqJsMeta } from "/var/www/html/fullstack-saas/frontend/pages/system-helper/[id].vue?macro=true";
import { default as test_45notificationsY2POMGxN_mK4qR7pbrWJNJ4GLLIm4LR3Hs07aa4nV7kMeta } from "/var/www/html/fullstack-saas/frontend/pages/test-notifications.vue?macro=true";
import { default as branch_45prscv8aUnMjDB0yVxvfxdsYeCK4j6N8I_e_h7EL2lK1HuEMeta } from "/var/www/html/fullstack-saas/frontend/pages/apps/[id]/branch-prs.vue?macro=true";
import { default as callbackJHgpEONwQ71kDGPOxRswqQjHV9rCHidmIVLg9zTlfkEMeta } from "/var/www/html/fullstack-saas/frontend/pages/auth/github/callback.vue?macro=true";
import { default as deploymentsdO1VBQTk8IcEyI1o9Syms0Ef6YhAyoPBgG5mf6_45CcIUMeta } from "/var/www/html/fullstack-saas/frontend/pages/apps/[id]/deployments.vue?macro=true";
import { default as process_45testAHo_eaBvG2sIyK06_45EJuqd3W1ft7pbwmN4UbiLseElUMeta } from "/var/www/html/fullstack-saas/frontend/pages/apps/[id]/process-test.vue?macro=true";
import { default as permissionsPHMltnb7BfG12nPl3giKWCh4yg1NvHTj9qhW_3DARyUMeta } from "/var/www/html/fullstack-saas/frontend/pages/users/[id]/permissions.vue?macro=true";
import { default as pull_45requestsFB1xoEyjmfVzFw7M3ga2Hzs7F_45cHMPwT22mWQCD41FUMeta } from "/var/www/html/fullstack-saas/frontend/pages/apps/[id]/pull-requests.vue?macro=true";
import { default as repo_45analysis3npGOi_455hGE_45mpniFTDTEaOdPncdfTwMoH1be8yK7VQMeta } from "/var/www/html/fullstack-saas/frontend/pages/apps/[id]/repo-analysis.vue?macro=true";
import { default as app_45managementANOUvkW5WRjj5NQDBEv1zrXw24PdUFTWFUjzlkM2oaEMeta } from "/var/www/html/fullstack-saas/frontend/pages/apps/[id]/app-management.vue?macro=true";
import { default as folder_45analysis7UtrHuDwC8Hk9gkDUGod43benU9WmzExoPqX1ZxnM0UMeta } from "/var/www/html/fullstack-saas/frontend/pages/apps/[id]/folder-analysis.vue?macro=true";
import { default as reset_45passwordYwGKyC3LzIHyxoJ2zfjxNu_cieuAfkCMiahGHvxnTNYMeta } from "/var/www/html/fullstack-saas/frontend/pages/users/[id]/reset-password.vue?macro=true";
import { default as test_45browser_45notificationsk0UTrUYdeF7V_45_8wqiUl0yNA_nSxEkKZeVib9x6Hps4Meta } from "/var/www/html/fullstack-saas/frontend/pages/test-browser-notifications.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexISdlP3zxlAyo4efWhwLYqUpfT_45UzAIQCTBT9ddG7eCgMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginYegehGnjP2bX_1TWUvkzPJnHZgKQCtt64G6F7jy1Mi4Meta || {}), ...{"middleware":"guest"} },
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/login.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/profile.vue")
  },
  {
    name: "apps-new",
    path: "/apps/new",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/apps/new.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/settings.vue")
  },
  {
    name: "apps",
    path: "/apps",
    meta: { ...(indexQ_45NwTdEOfdhrgmSrApmEpfVSMJl4qJTsviyGQXw_45hEQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/apps/index.vue")
  },
  {
    name: "roles",
    path: "/roles",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/roles/index.vue")
  },
  {
    name: "ui-showcase",
    path: "/ui-showcase",
    meta: ui_45showcaseotxqsT79SleLprDmKzjGHkAA5ssOvnlZbHbuAkwudN0Meta || {},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/ui-showcase.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/users/index.vue")
  },
  {
    name: "github",
    path: "/github",
    meta: { ...(index6AZgnUnJTI6IpJ3Jrquc2FgCVsNkEAb9ZS9tHQ0EXYcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/github/index.vue")
  },
  {
    name: "log-analysis",
    path: "/log-analysis",
    meta: { ...(log_45analysis5q3h_45zYPtIpKANvJXiAhbAxu6pq5jax2i25cAwQutjIMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/log-analysis.vue")
  },
  {
    name: "process-test",
    path: "/process-test",
    meta: { ...(process_45test6q6l5McYnGsb_45ojimscvJ6lAvaokk5KpoASgR0MhNB4Meta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/process-test.vue")
  },
  {
    name: "unauthorized",
    path: "/unauthorized",
    meta: unauthorizedRMAB8Ucx0YoSPIBPMoAgOYJgKgP5_vl7rqsY1tXTJ4gMeta || {},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/unauthorized.vue")
  },
  {
    name: "users-create",
    path: "/users/create",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/users/create.vue")
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/auth/callback.vue")
  },
  {
    name: "build-history",
    path: "/build-history",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/build-history.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/notifications.vue")
  },
  {
    name: "apps-id-edit",
    path: "/apps/:id()/edit",
    meta: editrArGqS8ccf2oFUXqEhD6GQ2AdWOMXYucsQprylW37ioMeta || {},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/apps/[id]/edit.vue")
  },
  {
    name: "apps-id-logs",
    path: "/apps/:id()/logs",
    meta: { ...(logsAfljNU_JqwTFK_455ZvyDfMMnY8YbcaMaEdY9dYrSo1qAMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/apps/[id]/logs.vue")
  },
  {
    name: "build-analysis",
    path: "/build-analysis",
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/build-analysis.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/reset-password.vue"),
    children: [
  {
    name: "reset-password-confirm",
    path: "confirm",
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/reset-password/confirm.vue")
  }
]
  },
  {
    name: "apps-id",
    path: "/apps/:id()",
    meta: indexQjWwSI3RBic3GTiJqthKXsQs_jRlb5gcO_45uch1BKOH4Meta || {},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/apps/[id]/index.vue")
  },
  {
    name: "users-index-new",
    path: "/users/index-new",
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/users/index-new.vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/users/[id]/index.vue")
  },
  {
    name: "system-helper-id",
    path: "/system-helper/:id()",
    meta: { ...(_91id_93jo4rwlGVtokDAPAtGgKbyxUMtJ50X9uUVTTLR_oLqJsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/system-helper/[id].vue")
  },
  {
    name: "test-notifications",
    path: "/test-notifications",
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/test-notifications.vue")
  },
  {
    name: "apps-id-branch-prs",
    path: "/apps/:id()/branch-prs",
    meta: { ...(branch_45prscv8aUnMjDB0yVxvfxdsYeCK4j6N8I_e_h7EL2lK1HuEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/apps/[id]/branch-prs.vue")
  },
  {
    name: "auth-github-callback",
    path: "/auth/github/callback",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/auth/github/callback.vue")
  },
  {
    name: "apps-id-deployments",
    path: "/apps/:id()/deployments",
    meta: deploymentsdO1VBQTk8IcEyI1o9Syms0Ef6YhAyoPBgG5mf6_45CcIUMeta || {},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/apps/[id]/deployments.vue")
  },
  {
    name: "apps-id-process-test",
    path: "/apps/:id()/process-test",
    meta: { ...(process_45testAHo_eaBvG2sIyK06_45EJuqd3W1ft7pbwmN4UbiLseElUMeta || {}), ...{"middleware":["auth","permission"]} },
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/apps/[id]/process-test.vue")
  },
  {
    name: "users-id-permissions",
    path: "/users/:id()/permissions",
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/users/[id]/permissions.vue")
  },
  {
    name: "apps-id-pull-requests",
    path: "/apps/:id()/pull-requests",
    meta: pull_45requestsFB1xoEyjmfVzFw7M3ga2Hzs7F_45cHMPwT22mWQCD41FUMeta || {},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/apps/[id]/pull-requests.vue")
  },
  {
    name: "apps-id-repo-analysis",
    path: "/apps/:id()/repo-analysis",
    meta: repo_45analysis3npGOi_455hGE_45mpniFTDTEaOdPncdfTwMoH1be8yK7VQMeta || {},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/apps/[id]/repo-analysis.vue")
  },
  {
    name: "apps-id-app-management",
    path: "/apps/:id()/app-management",
    meta: app_45managementANOUvkW5WRjj5NQDBEv1zrXw24PdUFTWFUjzlkM2oaEMeta || {},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/apps/[id]/app-management.vue")
  },
  {
    name: "apps-id-folder-analysis",
    path: "/apps/:id()/folder-analysis",
    meta: { ...(folder_45analysis7UtrHuDwC8Hk9gkDUGod43benU9WmzExoPqX1ZxnM0UMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/apps/[id]/folder-analysis.vue")
  },
  {
    name: "users-id-reset-password",
    path: "/users/:id()/reset-password",
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/users/[id]/reset-password.vue")
  },
  {
    name: "test-browser-notifications",
    path: "/test-browser-notifications",
    meta: test_45browser_45notificationsk0UTrUYdeF7V_45_8wqiUl0yNA_nSxEkKZeVib9x6Hps4Meta || {},
    component: () => import("/var/www/html/fullstack-saas/frontend/pages/test-browser-notifications.vue")
  }
]